import { InfoNotice } from '@/components/patterns/info-notice'
import { useOrganizationContext } from '@/hooks/useOrganizationContext'
import dayjs from '@/lib/dayjs'
import { FlaskConical } from 'lucide-react'
import { useState } from 'react'

const dismissalKeyPrefix = 'sales-demo-dashboard-notice-v1'

function dismissalKey(organization, salesDemo) {
  if (!organization?.id) {
    return null
  }

  return `${dismissalKeyPrefix}:${organization.id}:${salesDemo?.expires_at ?? 'active'}`
}

function isDismissed(key) {
  if (!key) {
    return false
  }

  try {
    return globalThis.localStorage?.getItem(key) === 'dismissed'
  } catch {
    return false
  }
}

export default function SalesDemoBanner({ className = '' }) {
  const { organization } = useOrganizationContext()
  const salesDemo = organization?.sales_demo
  const noticeKey = dismissalKey(organization, salesDemo)
  const [dismissedNoticeKey, setDismissedNoticeKey] = useState(null)

  if (!salesDemo?.is_active || dismissedNoticeKey === noticeKey || isDismissed(noticeKey)) {
    return null
  }

  const expiresAt = dayjs(salesDemo.expires_at)
  const expirationLabel = expiresAt.isValid()
    ? expiresAt.tz(organization.timezone).format('MMM D, YYYY [at] h:mm A z')
    : null

  const dismiss = () => {
    setDismissedNoticeKey(noticeKey)

    try {
      globalThis.localStorage?.setItem(noticeKey, 'dismissed')
    } catch {
      // Closing still works when browser storage is unavailable.
    }
  }

  return (
    <InfoNotice
      compact
      tone="info"
      icon={<FlaskConical />}
      title="Sales demo workspace"
      className={className}
      onDismiss={dismiss}
      dismissLabel="Dismiss sales demo notice"
    >
      This workspace uses practice data and test payments. Notifications are disabled. Integrations
      with Flower Shop Network and sympathy providers are disabled.
      {expirationLabel ? ` Access ends ${expirationLabel}.` : ''}
    </InfoNotice>
  )
}
